import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUserStore';
import { useSettingsStore } from '@/store/useSettingsStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useAuthModals } from '@/composables/useAuthModals';

export const useAuthActions = () => {
  const userStore = useUserStore();
  const viewerItemStore = useViewerItemStore();
  const { isLoggedIn } = storeToRefs(userStore);
  const { hideBranding } = storeToRefs(viewerItemStore);
  const { showSignUpModal } = useAuthModals();
  const { secondaryBaseDomain, isCustomDomain } = storeToRefs(useSettingsStore());

  const showAuthModal = () => {
    // if the origin domain is not share.getcloudapp.com proceed with signup modal logic
    if (!isLoggedIn.value && !hideBranding.value && !(secondaryBaseDomain?.value && origin.search(secondaryBaseDomain.value) > -1) && !isCustomDomain?.value) {
      showSignUpModal({
        sidebarText: 'Join Zight to add your name to the conversation',
        signedUpFrom: 'viewer_download',
      });
      return true;
    }
    return false;
  };

  return { showAuthModal };
};
